// extracted by mini-css-extract-plugin
export var blue = "_2i-f";
export var brand = "_2i-b";
export var darkGrey = "_2i-e";
export var disabled = "_2i-4";
export var disabledSubtle = "_2i-5";
export var error = "_2i-6";
export var green = "_2i-g";
export var grey = "_2i-d";
export var icon = "_2i-0";
export var inherit = "_2i-a";
export var lightGrey = "_2i-c";
export var orange = "_2i-i";
export var pink = "_2i-k";
export var primary = "_2i-1";
export var purple = "_2i-l";
export var red = "_2i-j";
export var secondary = "_2i-2";
export var success = "_2i-9";
export var tertiary = "_2i-3";
export var warning = "_2i-7";
export var warningSecondary = "_2i-8";
export var white = "_2i-m";
export var yellow = "_2i-h";